import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { isTenant as isTenantSelector } from 'features/user/selectors/userSelectors';
import { saveFilters, clearFilters } from 'features/pagination/actions/paginationActions';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { AppState } from 'common/appState';
import { EditContractFilter } from 'features/edit/components/EditContractFilter';

import { FilterDrawer } from './FilterDrawer';

interface Props {
    visible: boolean;
    onClose: () => void;
    onApply?: () => void;
    filterId?: PaginationView;
}

export const FilterDrawerContracts: React.FC<Props> = ({
    visible,
    onClose,
    onApply,
    filterId = PaginationView.Contracts,
}) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const tenant = useSelector(isTenantSelector);
    const formInitial = useSelector((state: AppState) => getFilterParams(state, filterId));

    const handleSaveFilters = (filters: PaginationFilters) => {
        dispatch(saveFilters({ ...filters, path: pathname }));
        onClose();
        if (onApply) {
            setTimeout(() => onApply(), 50);
        }
    };

    const handleClearFilters = (view?: PaginationView) => {
        dispatch(clearFilters(view || filterId));
        onClose();
        if (onApply) {
            setTimeout(() => onApply(), 50);
        }
    };

    return (
        <FilterDrawer visible={visible} onClose={onClose} title="Filter Projects">
            {visible && (
                <EditContractFilter
                    tenant={tenant}
                    formInitial={formInitial}
                    saveFilters={handleSaveFilters}
                    clearFilters={handleClearFilters}
                    paginatedView={filterId}
                />
            )}
        </FilterDrawer>
    );
};
